import EmptyStateNotice from '@/components/EmptyStateNotice';
import DetailsError from '@/components/modals/workflowLogsModal/DetailsError';
import DetailsHeader from '@/components/modals/workflowLogsModal/DetailsHeader';
import DetailsInfoSection from '@/components/modals/workflowLogsModal/DetailsInfoSection';
import DetailsLogSection from '@/components/modals/workflowLogsModal/DetailsLogSection';
import WorkflowLogsModalSummary from '@/components/modals/workflowLogsModal/WorkflowLogsModalSummary';
import { FiAlertCircle } from '@/components/react-icons/main';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';

const WorkflowLogsModalDetails = () => {
  const activeLogId = useArgSelector(selectors.query, 'logId');
  const log = useArgSelector(selectors.workflowLogsById, activeLogId);
  const isLoadingLogById = useArgSelector(selectors.isLoading, 'getWorkflowLogById');

  if (activeLogId === 'summary') {
    return (
      <div className="workflow-logs-modal-details">
        <WorkflowLogsModalSummary />
      </div>
    );
  }

  if (!log && !isLoadingLogById) {
    return (
      <div className="workflow-logs-modal-details">
        <EmptyStateNotice title="Log not found" description="The requested workflow log could not be found or may have been deleted." icon={FiAlertCircle} />
      </div>
    );
  }

  if (!log && !isLoadingLogById) {
    return null;
  }

  return (
    <div className="workflow-logs-modal-details">
      <DetailsHeader />
      <DetailsInfoSection />
      <DetailsError />
      <DetailsLogSection />
    </div>
  );
};

export default WorkflowLogsModalDetails;
